/**
 * Whether the employee has at least one current position assignment
 * (primary or preparing-for). Matches checks used in GiveAccessToEmployeeWizard
 * and employee assignment cards.
 *
 * @param {Object|null|undefined} employee
 * @returns {boolean}
 */
export function employeeHasCurrentPositionAssignment(employee) {
  if (!employee) return false;

  if (employee.primary_position != null) return true;

  if (Array.isArray(employee.primary_positions) && employee.primary_positions.length > 0) {
    return true;
  }

  if (employee.preparing_for_position != null) return true;

  if (
    Array.isArray(employee.preparing_for_positions) &&
    employee.preparing_for_positions.length > 0
  ) {
    return true;
  }

  return false;
}
